import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

export const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose, message }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'sent' | 'error'>('idle');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setError('');

    const result = await login(email);

    if (result.success) {
      setStatus('sent');
    } else {
      setStatus('error');
      setError(result.error || 'Failed to send magic link');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-xl max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-serif text-amber-500">登入 / 註冊</h2>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-slate-300"
          >
            ✕
          </button>
        </div>

        {message && (
          <p className="text-slate-400 text-sm mb-4">{message}</p>
        )}

        {status === 'sent' ? (
          <div className="text-center py-8">
            <div className="text-4xl mb-4">📧</div>
            <p className="text-slate-300 mb-2">魔法連結已發送！</p>
            <p className="text-slate-500 text-sm">
              請檢查你的信箱 ({email})
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label className="block text-slate-400 text-sm mb-2">
              電子郵件
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="w-full bg-slate-800 border border-slate-600 rounded-lg px-4 py-2 text-slate-200 mb-4 focus:outline-none focus:border-amber-500"
            />

            {error && (
              <p className="text-red-400 text-sm mb-4">{error}</p>
            )}

            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full bg-amber-600 hover:bg-amber-500 text-white font-medium py-2 rounded-lg transition disabled:opacity-50"
            >
              {status === 'loading' ? '發送中...' : '發送登入連結'}
            </button>
          </form>
        )}

        <p className="text-slate-600 text-xs text-center mt-4">
          我們會發送一封包含登入連結的郵件，無需密碼
        </p>
      </div>
    </div>
  );
};
